export interface NotEnoughQuantityCategoryPayload {
    productId: number;
    storageId: number;
    quantity: number;
}

const NOT_ENOUGH_QUANTITY_CATEGORY_REGEX =
    /^storage_product_relation\.not_enough_quantity_(\d+)_(\d+)_(\d+(?:\.\d+)?)$/;

export const parseNotEnoughQuantityCategory = (category?: string): NotEnoughQuantityCategoryPayload | null => {
    const match = category?.match(NOT_ENOUGH_QUANTITY_CATEGORY_REGEX);
    if (!match) return null;

    const [, productId, storageId, quantity] = match;

    return {
        productId: Number(productId),
        storageId: Number(storageId),
        quantity: Number(quantity),
    };
};
